// src/pages/container_rental/components/timeline/TimelineDefs.tsx
//
// 공유 <defs>. 문서에 딱 한 번만 렌더하고, 각 행의 <svg> 는 fill="url(#id)" 로
// 이 패턴을 참조한다. (같은 문서 안이면 인라인 SVG 간 참조가 정상 동작한다.)
// 행마다 defs 를 복제하면 100행 × 4패턴 = 400개 노드가 되므로 의도적으로 분리했다.

import { HATCH_PATTERNS } from "../statusVisuals.ts";

export default function TimelineDefs() {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}
    >
      <defs>
        {HATCH_PATTERNS.map((p) => (
          <pattern
            key={p.id}
            id={p.id}
            width={p.size}
            height={p.size}
            patternUnits="userSpaceOnUse"
            patternTransform={`rotate(${p.angle})`}
          >
            {p.bg ? <rect width={p.size} height={p.size} fill={p.bg} /> : null}
            <line
              x1={0}
              y1={0}
              x2={0}
              y2={p.size}
              stroke={p.color}
              strokeWidth={p.strokeWidth}
              opacity={p.opacity ?? 1}
            />
          </pattern>
        ))}
      </defs>
    </svg>
  );
}
